export const PHASE_BAR_HEIGHT = 18;
export const TASK_BAR_WIDTH = 14;
export const TASK_BAR_HEIGHT = 22;
export const MILESTONE_SIZE = 14;
export const ROADMAP_MILESTONE_SIZE = 12;
export const KEY_DATE_WIDTH = 3;
